import React, { useEffect } from "react";
import Lenis from "lenis";
import { LangProvider } from "@/LangContext";
import Nav from "@/components/royale/Nav";
import Hero from "@/components/royale/Hero";
import Services from "@/components/royale/Services";
import Gallery from "@/components/royale/Gallery";
import Reviews from "@/components/royale/Reviews";
import GiftVoucher from "@/components/royale/GiftVoucher";
import Contact from "@/components/royale/Contact";
import Footer from "@/components/royale/Footer";
import FloatingBar from "@/components/royale/FloatingBar";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-forest text-cream p-8 text-center">
          <p>Algo salió mal — recarga la página / Something went wrong — please reload.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function Site() {
  return (
    <div className="grain relative bg-forest min-h-screen">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Reviews />
        <GiftVoucher />
        <Contact />
      </main>
      <Footer />
      <FloatingBar />
      <div className="h-14 md:hidden" />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <ErrorBoundary>
        <Site />
      </ErrorBoundary>
    </LangProvider>
  );
}
